// eslint-disable-next-line
const hexLUT: string[] = Array.from({ length: 256 }, (_, i) => (i + 256).toString(16).slice(1));

const RANDOM_STR_LENGTH = 24;

export function randomString(len: number = RANDOM_STR_LENGTH): string {
  const buf = new Uint8Array(len);
  crypto.getRandomValues(buf);

  let result = '';

  // eslint-disable-next-line
  for (let i = 0; i < buf.length; i++) {
    result += hexLUT[buf[i]];
  }

  return result;
}
